<div class="overflow-x-auto pb-2">

  <!-- Nagłówki kolumn -->
  <div class="product-row px-2">
    <div class="field" *ngFor="let header of viewHeaders" [class]="header.class">
      {{header.text}}
    </div>
  </div>

  <!-- Wiersze produktów -->
  <div class="products-bg bg-neutral-100 dark:bg-slate-900 p-2 rounded-xl">
    <ng-container *ngFor="let p of products; let i = index;">

      <!-- Wiersz produktu -->
      <div class="product-row flex items-center content-center" [class.bg-white]="striped && i % 2 === 0" [class.dark:bg-slate-800]="striped && i % 2 === 0" [class.rounded-lg]="striped && i % 2 === 0">

        <ng-container *ngFor="let tableHeader of viewHeaders">

          <!-- Nazwa produktu -->
          <ng-container *ngIf="tableHeader.name == 'name'">
            <div class="field xl relative" *ngIf="!readonly">
              <input autocomplete="off" [matAutocomplete]="productAuto" #productNameInput type="text" [value]="p.name"
                (change)="p.setName($event.target.value); onProductChange()" (input)="findProducts($event.target.value);" />

              <span (click)="productNameInput.click()" *ngIf="productNameInput.value == ''"
                class="absolute bottom-1 ms-2 error-text pointer-events-none">Wprowadź nazwę</span>

              <mat-autocomplete [displayWith]="displayProductNameFn"
                (optionSelected)="onOptionSelected($event, p)" #productAuto="matAutocomplete"
                class="relative pt-0 rounded-xl shadow-xl">
                <div
                  class="sticky top-0 z-10 -mt-6 mb-6 bg-neutral-200 left-0 px-4 pt-2 pb-2 dark:bg-slate-900 text-sm border-b">
                  Szukaj produkt
                </div>
                @for (product of foundProducts; track product) {
                <mat-option [value]="product" class="border-b">
                  <div class="text-md font-medium">{{ product.name }}</div>
                  <div class="text-sm">{{product.grossValue}} {{product.currency || 'PLN'}},
                    {{product.quantity}}x, Stawka: {{getVatRateLabel(product.vatRate)}}</div>
                </mat-option>
                }
              </mat-autocomplete>
            </div>
            <div class="field xl" *ngIf="readonly">{{ p.name }}</div>
          </ng-container>

          <!-- Jednostka miary -->
          <ng-container *ngIf="tableHeader.name == 'unitOfMeasure'">
            <div class="field xs" *ngIf="!readonly">
              <div
                class="realtive flex content-between cursor-pointer align-center w-13 items-center bg-card border dark:border-white p-1 pl-2 rounded-md"
                style="max-height:31px" [matMenuTriggerFor]="unitMenu">
                <span class="text-clip truncate w-10 text-sm">{{p.unitOfMeasure}}</span>
                <mat-icon class="w-3" class="icon-size-3" [svgIcon]="'tabler_solid:caret-down'"></mat-icon>
              </div>

              <mat-menu #unitMenu="matMenu" class="relative max-h-100">
                <div
                  class="sticky top-0 z-10 -mt-3 bg-neutral-200 left-0 w-i px-4 pt-2 pb-2 dark:bg-slate-900 text-sm border-b">
                  Jednostka miary
                </div>
                <button *ngFor="let measurementUnit of measurementUnits" mat-menu-item
                  (click)="p.setUnitOfMeasure(measurementUnit.value); onProductChange()">
                  <mat-icon *ngIf="p.unitOfMeasure == measurementUnit.value"
                    [svgIcon]="'tabler_outline:check'"></mat-icon>
                  {{measurementUnit?.viewValue}}
                </button>
              </mat-menu>
            </div>
            <div class="field xs text-center" *ngIf="readonly">{{ p.unitOfMeasure }}</div>
          </ng-container>

          <!-- Ilość -->
          <ng-container *ngIf="tableHeader.name == 'quantity'">
            <div class="field xs" *ngIf="!readonly">
              <input inputmode="numeric" quantity [value]="p.quantity"
                (change)="p.setQuantity($event.target.value); onProductChange()" />
            </div>
            <div class="field xs text-center" *ngIf="readonly">{{ p.quantity }}</div>
          </ng-container>

          <!-- Cena netto -->
          <ng-container *ngIf="tableHeader.name == 'netPrice'">
            <div class="field md" *ngIf="!readonly">
              <input decimalFormatter inputmode="numeric" step=".01" [value]="p.netPrice.toFixed(2)"
                (change)="p.setNetPrice($event.target.value); onProductChange()" />
            </div>
            <div class="field md text-right" *ngIf="readonly">{{ p.netPrice | number:'1.2-2' }}</div>
          </ng-container>

          <!-- Wartość netto -->
          <ng-container *ngIf="tableHeader.name == 'netValue'">
            <div class="field md text-center">
              {{toDecimal(p.netValue)}}
            </div>
          </ng-container>

          <!-- Stawka VAT -->
          <ng-container *ngIf="tableHeader.name == 'vatRate'">
            <div class="field xs" *ngIf="!readonly">
              <div
                class="flex content-between cursor-pointer align-center items-center bg-card border dark:border-white p-1 pl-2 rounded-md"
                style="max-height:31px" [matMenuTriggerFor]="vatMenu">
                {{getVatRateLabel(p.vatRate)}} <mat-icon class="icon-size-3" [svgIcon]="'tabler_solid:caret-down'"></mat-icon>
              </div>

              <mat-menu #vatMenu="matMenu" class="relative max-h-100">
                <div
                  class="sticky top-0 z-10 -mt-3 bg-neutral-100 left-0 w-full px-4 pt-2 pb-2 dark:bg-slate-900 text-sm border-b">
                  Stawka VAT
                </div>
                <button *ngFor="let rate of vatRates" mat-menu-item (click)="p.setTax(rate.value); onProductChange()">
                  <mat-icon *ngIf="p.vatRate == rate.value" [svgIcon]="'tabler_outline:check'"></mat-icon>
                  {{rate?.viewValue}}
                </button>
                <div class="p-4">
                  Aby wyświetlać inne stawki <br />
                  przejdz do <a routerLink="/konto/ustawienia/stawki-vat">ustawień stawek</a>.
                </div>
              </mat-menu>
            </div>
            <div class="field xs text-center" *ngIf="readonly">{{ getVatRateLabel(p.vatRate + '') }}</div>
          </ng-container>

          <!-- Kwota VAT -->
          <ng-container *ngIf="tableHeader.name == 'amountOfVat'">
            <div class="field md text-center">
              {{toDecimal(p.amountOfVat)}}
            </div>
          </ng-container>

          <!-- Wartość brutto -->
          <ng-container *ngIf="tableHeader.name == 'grossValue'">
            <div class="field md" *ngIf="!readonly">
              <input decimalFormatter inputmode="numeric" step=".01" [value]="p?.grossValue?.toFixed(2)"
                (change)="p.setGrossValue($event.target.value); onProductChange()" />
            </div>
            <div class="field md text-right font-medium" *ngIf="readonly">{{ p.grossValue | number:'1.2-2' }}</div>
          </ng-container>

          <!-- Opcje (usuwanie) -->
          <ng-container *ngIf="tableHeader.name == 'options'">
            <div class="field xs items-center text-center justify-self-center self-center place-self-center" *ngIf="!readonly">
              <button mat-icon-button (click)="onRemoveProduct(i)"
                      [disabled]="products.length <= minProducts">
                <mat-icon [svgIcon]="'tabler_outline:x'"></mat-icon>
              </button>
            </div>
            <div class="field xs" *ngIf="readonly"></div>
          </ng-container>

        </ng-container>

      </div>

      <!-- Prompt "Zapisz produkt" -->
      <div class="block product-row p-2" *ngIf="!readonly && p && p._id == null && !dismissedSavePrompts.has(p) && p.grossValue && isNumberGrossValue(p.grossValue) && p.grossValue > 0">
        Czy chcesz zapisać ten produkt? <span class="text-primary cursor-pointer"
          (click)="onSaveProduct(p)">Zapisz</span> <span class="text-yellow-500 cursor-pointer ml-2"
          (click)="onDismissSaveProduct(p)">Nie zapisuj</span>
      </div>

      <!-- GTU / PKWiU / Rabat -->
      <div *ngIf="!readonly && (hasGTU || hasPKWiU || hasDiscount)" class="flex product-row py-2 border-b gap-2 items-start">

        <!-- GTU Menu -->
        <div *ngIf="hasGTU" class="flex flex-col">
          <span class="text-xs text-gray-600 dark:text-gray-400 mb-1">GTU</span>
          <div
            class="flex content-between cursor-pointer align-center items-center bg-card border dark:border-white p-1 pl-2 pr-2 rounded-md"
            style="max-height:31px; min-width:80px" [matMenuTriggerFor]="gtuMenu">
            <span class="text-sm flex-1">{{p.gtu || 'Brak'}}</span>
            <mat-icon class="icon-size-3" [svgIcon]="'tabler_solid:caret-down'"></mat-icon>
          </div>

          <mat-menu #gtuMenu="matMenu" class="relative max-h-100">
            <div
              class="sticky top-0 z-10 -mt-3 bg-neutral-100 left-0 w-full px-4 pt-2 pb-2 dark:bg-slate-900 text-sm border-b">
              Kod GTU
            </div>
            <button mat-menu-item (click)="p.setGTU('')">
              <mat-icon *ngIf="p.gtu == ''" [svgIcon]="'tabler_outline:check'"></mat-icon>
              Brak
            </button>
            <button *ngFor="let gtuCode of gtu" mat-menu-item (click)="p.setGTU(gtuCode.id)">
              <mat-icon *ngIf="p.gtu == gtuCode.id" [svgIcon]="'tabler_outline:check'"></mat-icon>
              <div>
                <div class="font-medium">{{gtuCode.id}}</div>
                <div class="text-xs text-gray-600 dark:text-gray-400">{{gtuCode.text}}</div>
              </div>
            </button>
          </mat-menu>
        </div>

        <!-- PKWiU Input -->
        <div *ngIf="hasPKWiU" class="flex flex-col">
          <span class="text-xs text-gray-600 dark:text-gray-400 mb-1">PKWiU</span>
          <input
            type="text"
            class="bg-card border dark:border-white p-1 pl-2 pr-2 rounded-md text-sm"
            style="max-height:31px; min-width:100px"
            [value]="p.pkwiu || ''"
            (change)="p.setPKWiU($event.target.value)"
            placeholder="np. 10.20.10">
        </div>

        <!-- Rabat -->
        <select-dropdown *ngIf="hasDiscount" [label]="'Rabat %'" [toggleClass]="'no-arrow'" type="input"
          [selectedOption]="p.discount" (selectionChange)="p.setDiscount($event); onProductChange()"></select-dropdown>

      </div>

    </ng-container>
  </div>

</div>

<!-- Przycisk "Dodaj produkt" -->
<button *ngIf="!readonly && showAddButton" mat-button class="text-md mt-2" color="primary" (click)="onAddProduct()">
  <mat-icon [svgIcon]="'tabler_outline:plus'"></mat-icon>
  <span class="ml-2">Dodaj kolejny produkt</span>
</button>
